import PropTypes from 'prop-types';

import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';

import ImmutablePropTypes from 'react-immutable-proptypes';

import CloseIcon from '@/material-icons/400-24px/close.svg?react';
import { IconButton } from 'mastodon/components/icon_button';
import { LoadingIndicator } from 'mastodon/components/loading_indicator';

const messages = defineMessages({
  clearLocation: { id: 'compose_form.location.clear', defaultMessage: 'Remove location' },
});

function ComposeLocationBanner ({ intl, location, locationLoading, onClear }) {
  if (!location && !locationLoading) {
    return null;
  }

  return (
    <div className='compose-form__location' dir='auto'>
      {locationLoading && <LoadingIndicator />}
      {location && (
        <>
          <span className='compose-form__location-label'>{location.get('display_name')}</span>
          <span className='compose-form__location-coords'>
            {Number(location.get('latitude')).toFixed(5)}, {Number(location.get('longitude')).toFixed(5)}
          </span>
          <a href={location.get('openstreetmap_url')} target='_blank' rel='noopener noreferrer'>
            <FormattedMessage id='compose_form.openstreetmap' defaultMessage='OpenStreetMap' />
          </a>
          <IconButton
            iconComponent={CloseIcon}
            title={intl.formatMessage(messages.clearLocation)}
            onClick={onClear}
            inverted
          />
        </>
      )}
    </div>
  );
}

ComposeLocationBanner.propTypes = {
  intl: PropTypes.object.isRequired,
  location: ImmutablePropTypes.map,
  locationLoading: PropTypes.bool,
  onClear: PropTypes.func.isRequired,
};

export default injectIntl(ComposeLocationBanner);
